import { Fragment } from "react";
import type { WatchMonitoringSummary as WatchMonitoringSummaryData } from "@/shared/lib/types";
import styles from "./WatchMonitoringSummary.module.css";

export interface WatchMonitoringSummaryProps {
  summary?: WatchMonitoringSummaryData;
  className?: string;
}

const fallbackSummary: WatchMonitoringSummaryData = {
  lifecycle: { state: "UNKNOWN", label: "Status unavailable" },
  evaluation: { state: "UNKNOWN", label: "Evaluation unavailable" },
  data_quality: { state: "UNKNOWN", label: "Evidence not assessed" },
  alert_eligibility: { state: "UNKNOWN", label: "Eligibility unavailable" },
};

const AXES: Array<{ key: keyof WatchMonitoringSummaryData; label: string }> = [
  { key: "lifecycle", label: "Monitoring" },
  { key: "evaluation", label: "Latest check" },
  { key: "data_quality", label: "Evidence" },
  { key: "alert_eligibility", label: "Alerts" },
];

/** Compact, defined state axes for a Watch table row. */
export default function WatchMonitoringSummary({
  summary,
  className,
}: WatchMonitoringSummaryProps) {
  const safeSummary = summary ?? fallbackSummary;
  return (
    <dl
      className={[styles.root, className].filter(Boolean).join(" ")}
      aria-label="Monitoring summary"
    >
      {AXES.map(({ key, label }) => (
        <Fragment key={key}>
          <dt>{label}</dt>
          <dd title={safeSummary[key].state}>{safeSummary[key].label}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
